import { ArtiEnvironment } from './model';

export const environment: ArtiEnvironment = {
  dynamicSettings: false,
  production: false,
  debug: 'ArtifactRepository:*',
  apiUrl: 'https://api.int.sickag.cloud/artifact-repository/',

  oidc: {
    // Url of the Identity Provider
    issuer: 'https://id.uat.sick.com/auth/realms/sickservices',
    // The SPA's id. The SPA is registered with this id at the auth-server
    clientId: 'artifact-repository',
  },
  oidcPassChange: 'https://id.uat.sick.com/auth/realms/sickservices/account/password',
  oidcProfile: 'https://id.uat.sick.com/auth/realms/sickservices/account/',
  groupManagement: {
    baseUrl: 'https://groups.uat-cloud.sick.com',
    apiUrl: 'https://groups.uat-cloud.sick.com/api/',
    adminGroupId: '081bc99a-6a4b-4c68-8136-427e531fcb36',
  },
  featureToggles: {},
  additionalLanguages: ['de'],
};
